<template>
    <HomeLayout>
        <section class="page-hero">
            <div class="page-hero-content">
                <div class="page-eyebrow"><span></span> Help Centre</div>
                <h1>Frequently Asked <em>Questions</em></h1>
                <p>Everything you need to know about Succour, our services, and how we work. Can't find what you're
                    looking for? Chat with us.</p>
            </div>
        </section>
        <div class="faq-layout">
            <aside class="faq-sidebar">
                <h3>Categories</h3>
                <a href="#general-information" class="faq-cat active">General Information</a><a href="#services"
                    class="faq-cat ">Services</a><a href="#screening-&-safety" class="faq-cat ">Screening & Safety</a><a
                    href="#billing-&-payments" class="faq-cat ">Billing & Payments</a><a href="#contact-&-support"
                    class="faq-cat ">Contact & Support</a>
            </aside>
            <main>
                <div class="faq-group" id="general-information">
                    <div class="faq-group-title">General Information</div>
                    <div class="faq-item">
                        <button class="faq-q"
                            onclick="this.classList.toggle('open');this.nextElementSibling.classList.toggle('open')">What
                            is Succour?<span class="arrow">▾</span></button>
                        <div class="faq-a">Succour is a mission driven caretech platform that connects families and
                            individuals with verified caregivers across Africa. Our goal is to match those needing care
                            with trusted professionals providing safe, compassionate, and high-quality services.</div>
                    </div>
                    <div class="faq-item">
                        <button class="faq-q"
                            onclick="this.classList.toggle('open');this.nextElementSibling.classList.toggle('open')">How
                            does Succour work?<span class="arrow">▾</span></button>
                        <div class="faq-a">Succour uses a requirements-based matching system that connects care seekers
                            with qualified caregivers. Families can browse verified profiles, read reviews, and request
                            the caregiver that best fits their needs. We then support the entire deployment and
                            post-placement process.</div>
                    </div>
                    <div class="faq-item">
                        <button class="faq-q"
                            onclick="this.classList.toggle('open');this.nextElementSibling.classList.toggle('open')">Who
                            can use Succour?<span class="arrow">▾</span></button>
                        <div class="faq-a">Succour is designed for families seeking reliable care for children, elderly
                            relatives, or their home and for caregivers looking to build meaningful careers. Investors
                            and partners who share our mission are also welcome.</div>
                    </div>
                    <div class="faq-item">
                        <button class="faq-q"
                            onclick="this.classList.toggle('open');this.nextElementSibling.classList.toggle('open')">Is
                            Succour available in my area?<span class="arrow">▾</span></button>
                        <div class="faq-a">We are continuously expanding. You can check our platform for current
                            coverage. If we're not yet in your area, stay tuned we're growing fast across Nigeria and
                            beyond.</div>
                    </div>
                </div>
                <div class="faq-group" id="services">
                    <div class="faq-group-title">Services</div>
                    <div class="faq-item">
                        <button class="faq-q"
                            onclick="this.classList.toggle('open');this.nextElementSibling.classList.toggle('open')">What
                            care services does Succour provide?<span class="arrow">▾</span></button>
                        <div class="faq-a">Succour connects families with caregivers across Child Care, Elderly Care,
                            and Housekeeping. Each category includes both live in and live out options to suit your
                            household's needs.</div>
                    </div>
                    <div class="faq-item">
                        <button class="faq-q"
                            onclick="this.classList.toggle('open');this.nextElementSibling.classList.toggle('open')">What
                            is the difference between live in and live out care?<span class="arrow">▾</span></button>
                        <div class="faq-a">A live in caregiver resides in your home, providing round-the-clock support.
                            A live out caregiver comes to your home during agreed hours and returns to their own
                            residence at the end of the day.</div>
                    </div>
                    <div class="faq-item">
                        <button class="faq-q"
                            onclick="this.classList.toggle('open');this.nextElementSibling.classList.toggle('open')">Can
                            I request more than one caregiver?<span class="arrow">▾</span></button>
                        <div class="faq-a">Yes. Families with multiple care needs for example, both elderly care and
                            child care can request multiple caregivers and manage them through your Succour account.
                        </div>
                    </div>
                </div>
                <div class="faq-group" id="screening-&-safety">
                    <div class="faq-group-title">Screening & Safety</div>
                    <div class="faq-item">
                        <button class="faq-q"
                            onclick="this.classList.toggle('open');this.nextElementSibling.classList.toggle('open')">How
                            does Succour ensure safety?<span class="arrow">▾</span></button>
                        <div class="faq-a">Every caregiver on Succour undergoes a comprehensive verification process:
                            medical health checks, criminal background checks, and guarantor verification all completed
                            before deployment to any family.</div>
                    </div>
                    <div class="faq-item">
                        <button class="faq-q"
                            onclick="this.classList.toggle('open');this.nextElementSibling.classList.toggle('open')">Are
                            all caregivers trained?<span class="arrow">▾</span></button>
                        <div class="faq-a">Yes. Beyond screening, Succour supports ongoing caregiver development through
                            micro-learning, periodic training, ratings, and performance reviews to maintain the highest
                            standards post-deployment.</div>
                    </div>
                    <div class="faq-item">
                        <button class="faq-q"
                            onclick="this.classList.toggle('open');this.nextElementSibling.classList.toggle('open')">What
                            happens if I'm unhappy with my caregiver?<span class="arrow">▾</span></button>
                        <div class="faq-a">Succour provides post-deployment support and a structured review process. If
                            a placement isn't working, our team is here to help find a resolution or facilitate a
                            rematch.</div>
                    </div>
                </div>
                <div class="faq-group" id="billing-&-payments">
                    <div class="faq-group-title">Billing & Payments</div>
                    <div class="faq-item">
                        <button class="faq-q"
                            onclick="this.classList.toggle('open');this.nextElementSibling.classList.toggle('open')">How
                            does billing work on Succour?<span class="arrow">▾</span></button>
                        <div class="faq-a">Billing arrangements are discussed and agreed during the onboarding process.
                            Our team provides clear, transparent pricing before any commitment is made.</div>
                    </div>
                    <div class="faq-item">
                        <button class="faq-q"
                            onclick="this.classList.toggle('open');this.nextElementSibling.classList.toggle('open')">Are
                            there any hidden fees?<span class="arrow">▾</span></button>
                        <div class="faq-a">No. We believe in total transparency. All fees are communicated clearly
                            upfront, with no surprises.</div>
                    </div>
                </div>
                <div class="faq-group" id="contact-&-support">
                    <div class="faq-group-title">Contact & Support</div>
                    <div class="faq-item">
                        <button class="faq-q"
                            onclick="this.classList.toggle('open');this.nextElementSibling.classList.toggle('open')">How
                            can I contact Succour for support?<span class="arrow">▾</span></button>
                        <div class="faq-a">You can reach our team via WhatsApp, email at <a
                                href="/cdn-cgi/l/email-protection" class="__cf_email__"
                                data-cfemail="e38b868f8f8ca3909680808c9691cd80829186">[email&#160;protected]</a>, or by
                            calling +234 918 000 2370. We're also available through the live chat on our website.</div>
                    </div>
                    <div class="faq-item">
                        <button class="faq-q"
                            onclick="this.classList.toggle('open');this.nextElementSibling.classList.toggle('open')">How
                            do I sign up as a caregiver?<span class="arrow">▾</span></button>
                        <div class="faq-a">Visit our Apply to Care Jobs page, complete your profile, provide proof of
                            qualifications, and undergo our verification process. Once verified, you'll be matched with
                            families who need your skills.</div>
                    </div>
                </div>
            </main>
        </div>
    </HomeLayout>
</template>

<script lang="js">
import HomeLayout from '../Layouts/HomeLayout.vue';
export default {
    name: "FAQ",
    components: {
        HomeLayout,
    },

}

</script>

<style lang="css" scoped>
:root {
    --pink: #F59CAB;
    --pink-light: #FDE8EC;
    --pink-mid: #F8C4CC;
    --green: #17865F;
    --green-dark: #0f5c41;
    --green-light: #E8F5EF;
    --cream: #FDF9F7;
    --orange: #FF9700;
    --text-dark: #1C2B27;
    --text-mid: #4A5E58;
    --text-light: #8A9E98;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html {
    scroll-behavior: smooth;
}

body {
    font-family: 'Open Sans', sans-serif;
    background: var(--cream);
    color: var(--text-dark);
    overflow-x: hidden;
}

.ribbon {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1100;
    background: var(--green);
    color: white;
    padding: 9px 20px;
    font-size: .84rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    box-shadow: 0 2px 12px rgba(23, 134, 95, .2);
}

.ribbon span {
    opacity: .88;
    font-weight: 300;
}

.ribbon a {
    background: white;
    color: var(--green);
    padding: 5px 16px;
    border-radius: 100px;
    font-weight: 700;
    font-size: .8rem;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: background .2s, color .2s;
}

.ribbon a:hover {
    background: var(--pink);
    color: white;
}

nav {
    position: fixed;
    top: 38px;
    left: 0;
    right: 0;
    z-index: 900;
    background: rgba(253, 249, 247, .96);
    backdrop-filter: blur(14px);
    border-bottom: 1px solid rgba(245, 156, 171, .12);
    padding: 0 6%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.nav-logo {
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
}

.logo-text {
    font-family: 'Open Sans', sans-serif;
    font-size: 1.35rem;
    font-weight: 700;
    color: var(--text-dark);
}

.logo-text sup {
    font-size: .5rem;
    color: var(--text-light);
    font-weight: 400;
}

.nav-links {
    display: flex;
    align-items: center;
    gap: 26px;
    list-style: none;
}

.nav-links a {
    font-size: .85rem;
    color: var(--text-mid);
    text-decoration: none;
    font-weight: 400;
    transition: color .2s;
    padding-bottom: 2px;
    border-bottom: 2px solid transparent;
}

.nav-links a:hover,
.nav-links a.active {
    color: var(--green);
    border-bottom-color: var(--green);
}

.nav-ctas {
    display: flex;
    align-items: center;
    gap: 10px;
}

.btn-ghost {
    font-family: 'Open Sans', sans-serif;
    font-size: .85rem;
    color: var(--text-mid);
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px 14px;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 400;
    transition: color .2s;
}

.btn-ghost:hover {
    color: var(--green);
}

.btn-primary {
    font-family: 'Open Sans', sans-serif;
    font-size: .85rem;
    font-weight: 700;
    background: var(--pink);
    color: white;
    border: none;
    padding: 10px 22px;
    border-radius: 100px;
    cursor: pointer;
    text-decoration: none;
    transition: background .2s, transform .15s;
}

.btn-primary:hover {
    background: #e8849a;
    transform: translateY(-1px);
}

.btn-green {
    font-family: 'Open Sans', sans-serif;
    font-size: .9rem;
    font-weight: 700;
    background: var(--green);
    color: white;
    border: none;
    padding: 13px 32px;
    border-radius: 100px;
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
    transition: background .2s, transform .15s;
}

.btn-green:hover {
    background: var(--green-dark);
    transform: translateY(-1px);
}

.btn-outline-green {
    font-family: 'Open Sans', sans-serif;
    font-size: .9rem;
    font-weight: 700;
    background: transparent;
    color: var(--green);
    border: 2px solid var(--green);
    padding: 11px 28px;
    border-radius: 100px;
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
    transition: background .2s, color .2s;
}

.btn-outline-green:hover {
    background: var(--green);
    color: white;
}

.page-hero {
    padding: 160px 7% 80px;
    background: var(--cream);
    position: relative;
    overflow: hidden;
}

.page-hero::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 45%;
    height: 100%;
    background: var(--pink-light);
    border-radius: 60px 0 0 60px;
    opacity: .45;
    z-index: 0;
}

.page-hero-content {
    position: relative;
    z-index: 1;
    max-width: 600px;
}

.page-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: var(--green-light);
    color: var(--green);
    font-size: .72rem;
    font-weight: 700;
    letter-spacing: .1em;
    text-transform: uppercase;
    padding: 6px 14px;
    border-radius: 100px;
    margin-bottom: 20px;
}

.page-eyebrow span {
    width: 6px;
    height: 6px;
    background: var(--green);
    border-radius: 50%;
}

.page-hero h1 {
    font-family: 'Lora', serif;
    font-size: clamp(2.2rem, 4vw, 3.4rem);
    font-weight: 400;
    line-height: 1.12;
    color: var(--text-dark);
    margin-bottom: 18px;
}

.page-hero h1 em {
    font-style: italic;
    color: var(--green);
}

.page-hero p {
    font-size: 1rem;
    color: var(--text-mid);
    line-height: 1.75;
    font-weight: 300;
    max-width: 500px;
}

.section-label {
    font-size: .72rem;
    font-weight: 700;
    letter-spacing: .12em;
    text-transform: uppercase;
    color: var(--pink);
    margin-bottom: 10px;
}

.section-title {
    font-family: 'Lora', serif;
    font-size: clamp(1.6rem, 2.6vw, 2.3rem);
    font-weight: 400;
    color: var(--text-dark);
    line-height: 1.2;
    margin-bottom: 12px;
}

.section-title em {
    font-style: italic;
    color: var(--green);
}

.section-sub {
    font-size: .95rem;
    color: var(--text-mid);
    max-width: 520px;
    line-height: 1.7;
    font-weight: 300;
    margin-bottom: 44px;
}

footer {
    background: var(--text-dark);
    padding: 68px 7% 30px;
}

.footer-grid {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 48px;
    margin-bottom: 56px;
}

.footer-logo-text {
    font-family: 'Open Sans', sans-serif;
    font-size: 1.3rem;
    font-weight: 700;
    color: white;
}

.footer-logo-text sup {
    font-size: .48rem;
    color: rgba(255, 255, 255, .3);
    font-weight: 400;
}

.footer-tagline {
    font-size: .83rem;
    color: rgba(255, 255, 255, .42);
    line-height: 1.7;
    margin: 14px 0 22px;
    font-weight: 300;
    max-width: 230px;
}

.footer-socials {
    display: flex;
    gap: 8px;
}

.social-btn {
    width: 34px;
    height: 34px;
    background: rgba(255, 255, 255, .07);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, .45);
    font-size: .78rem;
    text-decoration: none;
    font-weight: 700;
    transition: background .2s, color .2s;
}

.social-btn:hover {
    background: var(--pink);
    color: white;
}

.footer-col h4 {
    font-size: .72rem;
    font-weight: 700;
    letter-spacing: .1em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, .35);
    margin-bottom: 18px;
}

.footer-col ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.footer-col a {
    font-size: .85rem;
    color: rgba(255, 255, 255, .55);
    text-decoration: none;
    font-weight: 300;
    transition: color .2s;
}

.footer-col a:hover {
    color: var(--pink);
}

.footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, .07);
    padding-top: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.footer-bottom p {
    font-size: .76rem;
    color: rgba(255, 255, 255, .25);
    font-weight: 300;
}

@media(max-width:768px) {
    .nav-links {
        display: none;
    }

    .footer-grid {
        grid-template-columns: 1fr;
    }

    .page-hero {
        padding: 140px 5% 60px;
    }
}

.faq-layout {
    padding: 80px 7% 100px;
    background: white;
    display: grid;
    grid-template-columns: 240px 1fr;
    gap: 64px;
    align-items: start;
}

.faq-sidebar {
    position: sticky;
    top: 120px;
}

.faq-sidebar h3 {
    font-size: .72rem;
    font-weight: 700;
    letter-spacing: .1em;
    text-transform: uppercase;
    color: var(--text-light);
    margin-bottom: 16px;
}

.faq-cat {
    display: block;
    font-size: .88rem;
    color: var(--text-mid);
    text-decoration: none;
    padding: 10px 14px;
    border-radius: 10px;
    font-weight: 400;
    margin-bottom: 4px;
    transition: background .2s, color .2s;
    border-left: 3px solid transparent;
}

.faq-cat:hover,
.faq-cat.active {
    background: var(--green-light);
    color: var(--green);
    border-left-color: var(--green);
}

.faq-group {
    margin-bottom: 52px;
}

.faq-group-title {
    font-family: 'Lora', serif;
    font-size: 1.3rem;
    font-weight: 400;
    color: var(--text-dark);
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid var(--pink-light);
}

.faq-item {
    border: 1px solid rgba(245, 156, 171, .2);
    border-radius: 14px;
    margin-bottom: 12px;
    overflow: hidden;
    background: var(--cream);
}

.faq-q {
    width: 100%;
    text-align: left;
    padding: 18px 20px;
    background: none;
    border: none;
    font-family: 'Open Sans', sans-serif;
    font-size: .92rem;
    font-weight: 600;
    color: var(--text-dark);
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    transition: color .2s;
}

.faq-q:hover {
    color: var(--green);
}

.faq-q .arrow {
    font-size: 1rem;
    color: var(--pink);
    transition: transform .25s;
    flex-shrink: 0;
}

.faq-q.open .arrow {
    transform: rotate(180deg);
    color: var(--green);
}

.faq-a {
    display: none;
    padding: 0 20px 18px;
    font-size: .87rem;
    color: var(--text-mid);
    line-height: 1.75;
    font-weight: 300;
}

.faq-a.open {
    display: block;
}

@media(max-width:900px) {
    .faq-layout {
        grid-template-columns: 1fr;
    }

    .faq-sidebar {
        position: static;
    }
}

/* ── UNIVERSAL MOBILE SAFETY ── */
@media(max-width:480px) {

    .hero h1,
    .page-title {
        font-size: 2rem !important;
    }

    .section-title {
        font-size: 1.5rem !important;
    }

    nav {
        padding: 0 4%;
    }

    .nav-ctas .btn-ghost:first-child {
        display: none;
    }

    .ribbon {
        font-size: .78rem;
        padding: 8px 12px;
        gap: 6px;
    }

    .ribbon a {
        padding: 4px 10px;
        font-size: .75rem;
    }

    .hero-ctas {
        flex-direction: column;
    }

    .hero-ctas a {
        text-align: center;
    }

    .service-grid {
        grid-template-columns: 1fr !important;
    }

    .cg-grid {
        grid-template-columns: 1fr !important;
    }

    .steps {
        grid-template-columns: 1fr !important;
    }

    .steps::before {
        display: none !important;
    }

    .audience-grid {
        grid-template-columns: 1fr !important;
    }

    .testi-grid {
        grid-template-columns: 1fr !important;
    }

    .footer-grid {
        grid-template-columns: 1fr !important;
    }

    .about-story,
    .why,
    .pitch-grid,
    .contact-invest {
        grid-template-columns: 1fr !important;
    }

    .metrics {
        grid-template-columns: 1fr 1fr !important;
    }

    .opp-grid,
    .values-grid {
        grid-template-columns: 1fr !important;
    }

    .faq-layout,
    .legal-layout {
        grid-template-columns: 1fr !important;
        padding: 32px 5% 48px !important;
    }

    .faq-sidebar,
    .legal-sidebar {
        position: static !important;
    }

    .apply-cta {
        grid-template-columns: 1fr !important;
        padding: 32px 24px !important;
    }

    .values-grid {
        grid-template-columns: 1fr !important;
    }

    .page-banner {
        padding: 80px 5% 40px !important;
    }

    .services,
    .why,
    .how,
    .caregivers,
    .audience,
    .testimonials,
    .about-story,
    .values,
    .mission-strip,
    .traction,
    .opportunity {
        padding: 52px 5% !important;
    }

    .cg-grid {
        grid-template-columns: 1fr 1fr !important;
    }

    .hero-badge {
        display: none;
    }

    .invest-form {
        padding: 28px 20px !important;
    }
}

@media(max-width:1024px) {
    .faq-layout {
        grid-template-columns: 200px 1fr;
        gap: 32px;
    }

    .legal-layout {
        grid-template-columns: 190px 1fr;
        gap: 32px;
    }

    .metrics {
        grid-template-columns: repeat(2, 1fr);
    }

    .opp-grid {
        grid-template-columns: 1fr 1fr;
    }
}


/* WHATSAPP BUBBLE */
.wa-bubble {
    position: fixed;
    bottom: 28px;
    right: 28px;
    z-index: 2000;
    display: flex;
    align-items: center;
    gap: 0;
    cursor: pointer;
}

.wa-bubble-label {
    background: white;
    color: #1C2B27;
    font-family: 'Open Sans', sans-serif;
    font-size: .82rem;
    font-weight: 600;
    padding: 10px 16px;
    border-radius: 100px 0 0 100px;
    box-shadow: -4px 2px 14px rgba(0, 0, 0, .1);
    white-space: nowrap;
    max-width: 0;
    overflow: hidden;
    opacity: 0;
    transition: max-width .4s ease, opacity .3s ease, padding .3s ease;
    padding-left: 0;
    padding-right: 0;
}

.wa-bubble:hover .wa-bubble-label {
    max-width: 180px;
    opacity: 1;
    padding: 10px 16px;
}

.wa-btn {
    width: 56px;
    height: 56px;
    background: #25D366;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 20px rgba(37, 211, 102, .4);
    animation: waPulse 2.5s ease-in-out infinite;
    flex-shrink: 0;
    text-decoration: none;
}

.wa-btn svg {
    width: 28px;
    height: 28px;
    fill: white;
}

@keyframes waPulse {

    0%,
    100% {
        box-shadow: 0 4px 20px rgba(37, 211, 102, .4);
    }

    50% {
        box-shadow: 0 4px 32px rgba(37, 211, 102, .7), 0 0 0 8px rgba(37, 211, 102, .12);
    }
}

@media(max-width:480px) {
    .wa-bubble {
        bottom: 18px;
        right: 18px;
    }

    .wa-btn {
        width: 48px;
        height: 48px;
    }
}


.footer-socials {
    display: flex;
    gap: 10px;
}

.social-btn {
    width: 36px;
    height: 36px;
    background: rgba(255, 255, 255, .07);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    transition: background .2s;
}

.social-btn:hover {
    background: var(--pink);
}

.social-btn svg {
    width: 16px;
    height: 16px;
    fill: rgba(255, 255, 255, .55);
    transition: fill .2s;
}

.social-btn:hover svg {
    fill: white;
}
</style>